import React from "react";
import { routes } from "../configs/configNavLink";
import Layout from "../pages/Layout";
import Home from "../pages/home";
import NotFound from "../pages/NotFound";
import OrbiaPage from "../pages/orbia";
import BusinessCard from "../pages/BusinessCard";
import BusinessCardWhite from "../pages/BusinessCardWhite";
import BusinessCardMinimal from "../pages/BusinessCardMinimal";
// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    component: <Layout />,
    attributes: {
      path: "/",
      id: "Layout",
    },
    children: [
      {
        header: "Home",
        component: <Home />,
        attributes: {
          path: routes.home,
          id: "Home",
        },
      },
    ],
  },

  {
    component: <OrbiaPage />,
    attributes: {
      path: "/orbia",
      id: "OrbiaPage",
    },
  },

  {
    component: <BusinessCard />,
    attributes: {
      path: "/business-card",
      id: "BusinessCard",
    },
  },

  {
    component: <BusinessCardWhite />,
    attributes: {
      path: "/business-card-white",
      id: "BusinessCardWhite",
    },
  },

  {
    component: <BusinessCardMinimal />,
    attributes: {
      path: "/business-card-minimal",
      id: "BusinessCardMinimal",
    },
  },

  {
    component: <NotFound />,
    attributes: {
      path: "*",
      id: "notFound",
    },
  },
];
